<template>
  <div v-if="isShow" class="popFixed">
    <div class="masking" @click="closeBankPop" />
    <div class="tcCon">
      <div class="item">
        <span>温馨提示</span>
        <p>{{ errMessage }}</p>
      </div>
      <div class="btnCon" :class="pageType == 'app' ? 'only' : ''">
        <span v-if="pageType != 'app'" @click="closeBankPop">取消</span>
        <span @click="goPersonalInfo">去查看</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UnreviewedBank',
  props: ['source', 'isUnreviewedBank', 'errMessage', 'pageType', 'isUSDT'],
  data() {
    return {
      isShow: this.isUnreviewedBank
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    closeBankPop() {
      if (this.pageType != 'app') {
        if (this.source == 'home') {
          this.removeFixed()
          this.isShow = false
          this.$emit('changeUnreviewedBank', this.isShow)
        } else {
          this.$router.go(-1)
        }
      }
    },
    goPersonalInfo() {
      this.$bus.$emit('loading', false)
      this.$router.push({
        path: '/home/personalInfo'
      })
    }
  }
}
</script>
